<template>
  <v-card class="mb-6" variant="outlined">
    <v-row>
      <v-col class="pb-0">
        <v-card-title class="pb-0">
          <slot/>
        </v-card-title>
      </v-col>
      <template v-if="props.showEnable">
        <v-col class="pr-10 pb-0" cols="auto">
          <v-switch
            color="primary"
            label="Enable"
            hide-details
            v-model="enable"
            :density="props.density"
          />
        </v-col>
      </template>
    </v-row>
    <v-container class="pb-2">
      <v-row>
        <v-col cols="3" class="border-e-lg">
          <v-text-field
            type="number"
            min="0"
            label="Days"
            v-model="days"
            :disabled="!enable"
            :density="props.density"
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            type="number"
            min="0"
            max="23"
            label="Hours"
            v-model="hours"
            :disabled="!enable"
            :density="props.density"
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            type="number"
            min="0"
            max="59"
            label="Minutes"
            v-model="minutes"
            :disabled="!enable"
            :density="props.density"
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            type="number"
            min="0"
            max="59"
            label="Seconds"
            v-model="seconds"
            :disabled="!enable"
            :density="props.density"
            hide-details
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";

const enable = ref(false);

const props = defineProps({
  modelValue: {
    default: "0 0:0:0"
  },
  showEnable: {
    type: Boolean,
    default: false
  },
  density: {
    type: String,
    default: "default"
  }
});
const emit = defineEmits(['update:modelValue']);

onMounted(() => {
  if (!props.showEnable) {
    enable.value = true;
  } else {
    enable.value = props.modelValue !== null;
  }
});

watch(() => props.modelValue, (newValue) => {
  enable.value = newValue !== null;
});

watch(enable, (newValue) => {
  if (newValue) {
    emit('update:modelValue', timeToText(days.value, hours.value, minutes.value, seconds.value));
  } else {
    emit('update:modelValue', null);
  }
});


function textToTime(timeStr) {
  let days = 0, hours = 0, minutes = 0, seconds = 0;
  if (timeStr === null) return { days, hours, minutes, seconds };
  const parts = timeStr.split(/[: ]/);
  switch (parts.length) {
    case 4: // DD HH:MM:SS
      [days, hours, minutes, seconds] = parts.map(Number);
      break;
    case 3: // HH:MM:SS
      [hours, minutes, seconds] = parts.map(Number);
      break;
    case 2: // MM:SS
      [minutes, seconds] = parts.map(Number);
      break;
    case 1: // SS
      seconds = Number(parts[0]);
      break;
    default:
      throw new Error("Invalid time format");
  }

  return { days, hours, minutes, seconds };
}

function timeToText(days, hours, minutes, seconds) {
  if (enable.value) {
    return `${days} ${hours}:${minutes}:${seconds}`;
  } else {
    return null;
  }
}

const days = computed({
  get() {
    return textToTime(props.modelValue).days;
  },
  set(value) {
    emit('update:modelValue', timeToText(value, hours.value, minutes.value, seconds.value));
  }
});
const hours = computed({
  get() {
    return textToTime(props.modelValue).hours;
  },
  set(value) {
    emit('update:modelValue', timeToText(days.value, value, minutes.value, seconds.value));
  }
});
const minutes = computed({
  get() {
    return textToTime(props.modelValue).minutes;
  },
  set(value) {
    emit('update:modelValue', timeToText(days.value, hours.value, value, seconds.value));
  }
});
const seconds = computed({
  get() {
    return textToTime(props.modelValue).seconds;
  },
  set(value) {
    emit('update:modelValue', timeToText(days.value, hours.value, minutes.value, value));
  }
});

</script>

<style scoped>

</style>
